import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, MapPinIcon, CalendarIcon, BriefcaseIcon, CheckIcon, SparklesIcon, GraduationCapIcon, ClipboardCheckIcon, AwardIcon, ExternalLinkIcon, FileTextIcon } from 'lucide-react';
// Sample scholarship data (in a real app, this would come from an API)
const scholarshipsData = [{
  id: 'sch001',
  title: 'Elite Track: Computer Science at MIT',
  track: 'Elite',
  university: 'Massachusetts Institute of Technology',
  program: 'Computer Science',
  location: 'United States',
  deadline: '2023-12-15',
  coverageTypes: ['Tuition', 'Living Allowance', 'Travel', 'Books & Materials'],
  description: 'Full scholarship for outstanding Emirati students to pursue Computer Science at MIT, with a focus on AI and machine learning.',
  eligibility: ['UAE Nationals', 'GPA 3.8+', 'IELTS 7.5+'],
  logo: 'MIT',
  longDescription: "The Elite Track Computer Science scholarship at MIT offers a unique opportunity for exceptional Emirati students to study at one of the world's leading institutions for technology and innovation. This comprehensive scholarship covers all aspects of your educational journey, including full tuition, living expenses, travel costs, and academic materials. The program focuses on advanced areas of computer science, with particular emphasis on artificial intelligence, machine learning, and data science - fields that are critical to the UAE's future development plans. Scholars will have access to MIT's cutting-edge research facilities, world-renowned faculty, and a vibrant innovation ecosystem. Upon graduation, scholars are expected to return to the UAE and contribute to the nation's knowledge economy and digital transformation initiatives.",
  requirements: ['UAE National', 'High school graduate or equivalent', 'Minimum GPA of 3.8 or equivalent', 'IELTS score of 7.5+ or TOEFL equivalent', 'Strong background in mathematics and computer science', 'Demonstrated leadership potential', 'Statement of purpose and academic goals', 'Three letters of recommendation'],
  benefits: ['Full tuition coverage for the entire program duration', 'Monthly living allowance', 'Annual round-trip air tickets to the university', 'Health insurance coverage', 'Book and laptop allowance', 'Research funding opportunities', 'Conference attendance support', 'Mentorship from industry leaders'],
  applicationProcess: ['Complete the online application form', 'Submit all required documents including transcripts and test scores', 'Initial screening by the scholarship committee', 'Technical assessment in mathematics and computer science', 'Interview with the selection committee', 'Final decision notification']
}, {
  id: 'sch003',
  title: 'ADNOC Future Energy Leaders',
  track: 'Partnership',
  university: 'Stanford University',
  program: 'Petroleum Engineering',
  location: 'United States',
  deadline: '2023-11-15',
  coverageTypes: ['Tuition', 'Living Allowance', 'Travel', 'Books & Materials'],
  description: 'ADNOC-sponsored scholarship for future energy leaders with guaranteed employment upon graduation.',
  eligibility: ['UAE Nationals', 'GPA 3.5+', 'IELTS 6.5+'],
  employer: 'ADNOC',
  logo: 'ADNOC',
  longDescription: 'The ADNOC Future Energy Leaders scholarship is a prestigious program designed to develop the next generation of leaders in the energy sector. Through this partnership with Stanford University, ADNOC aims to build a pipeline of highly qualified Emirati talent in petroleum engineering and related fields. This scholarship offers comprehensive financial support, mentorship opportunities, and guaranteed employment with ADNOC upon successful graduation. Scholars will gain world-class education at Stanford University, known for its cutting-edge research in sustainable energy technologies and petroleum engineering. The program includes summer internships at ADNOC facilities, allowing scholars to apply their theoretical knowledge in real-world settings and build professional networks within the company.',
  requirements: ['UAE National', "Bachelor's degree in Engineering or related field", 'Minimum GPA of 3.5', 'IELTS score of 6.5+ or TOEFL equivalent', 'Strong background in mathematics and physics', 'Demonstrated interest in the energy sector', "Statement of purpose aligned with ADNOC's strategic goals", 'Two letters of recommendation'],
  benefits: ['Full tuition coverage', 'Monthly stipend for living expenses', 'Annual round-trip tickets', 'Health insurance', 'Books and supplies allowance', 'Guaranteed employment at ADNOC upon successful completion', 'Summer internships at ADNOC facilities', 'Mentorship from ADNOC executives'],
  applicationProcess: ['Submit online application', 'Initial screening by ADNOC HR team', 'Technical assessment', 'Panel interview with ADNOC representatives', 'Final selection and notification']
}, {
  id: 'sch004',
  title: 'Mubadala Tech Innovators',
  track: 'Partnership',
  university: 'Multiple Options',
  program: 'Computer Science / Data Science',
  location: 'Multiple Locations',
  deadline: '2023-12-01',
  coverageTypes: ['Tuition', 'Living Allowance'],
  description: 'Mubadala-sponsored scholarship for tech innovators with flexible university options from the approved list.',
  eligibility: ['UAE Nationals', 'GPA 3.5+', 'IELTS 6.5+'],
  employer: 'Mubadala',
  logo: 'Mubadala',
  longDescription: "The Mubadala Tech Innovators Scholarship Program is designed to develop future technology leaders who will drive innovation and digital transformation in the UAE. This flexible program allows scholars to choose from a select list of top global universities, based on their specific interests in computer science or data science. Mubadala Investment Company sponsors this initiative as part of its commitment to building a knowledge-based economy in the UAE. Scholars receive comprehensive financial support and are offered employment opportunities within Mubadala's portfolio companies upon graduation. The program emphasizes practical experience alongside academic excellence, with opportunities for internships and project work with Mubadala's technology investments and partners.",
  requirements: ['UAE National', "Bachelor's degree with minimum GPA of 3.5", 'IELTS score of 6.5+ or equivalent', 'Strong background in computer science, mathematics, or related fields', 'Portfolio of technical projects (if applicable)', 'Statement of purpose outlining technology interests', 'Two letters of recommendation'],
  benefits: ['Full tuition coverage', 'Monthly living stipend', 'Laptop allowance', 'Professional certification allowances', 'Internship opportunities with Mubadala portfolio companies', 'Mentorship from technology leaders', 'Employment opportunities after graduation'],
  applicationProcess: ['Online application submission', 'Technical portfolio review', 'Skills assessment in programming and data analysis', 'Interview with Mubadala technology team', 'University selection and placement', 'Final approval and award notification']
}, {
  id: 'sch006',
  title: 'Emirates Future Leaders',
  track: 'Partnership',
  university: 'Multiple Options',
  program: 'Aviation Management',
  location: 'Multiple Locations',
  deadline: '2023-11-20',
  coverageTypes: ['Tuition', 'Living Allowance', 'Travel'],
  description: 'Emirates-sponsored scholarship for future aviation leaders with guaranteed employment upon graduation.',
  eligibility: ['UAE Nationals', 'GPA 3.3+', 'IELTS 6.5+'],
  employer: 'Emirates',
  logo: 'Emirates',
  longDescription: "The Emirates Future Leaders Scholarship Program is designed to develop the next generation of aviation industry professionals. Sponsored by Emirates, one of the world's leading airlines, this program offers Emirati students the opportunity to pursue degrees in aviation management and related fields at selected international universities. The scholarship provides comprehensive financial support and includes a guaranteed employment pathway with Emirates upon successful completion. Scholars will gain expertise in various aspects of airline operations, management, and strategy, preparing them for leadership roles in the aviation sector. The program includes practical training components and internships within Emirates operations, allowing scholars to gain hands-on experience in the industry.",
  requirements: ['UAE National', "Bachelor's degree with minimum GPA of 3.3", 'IELTS score of 6.5+ or equivalent', 'Interest in aviation industry', 'Strong communication and leadership skills', 'Statement of career goals in aviation', 'Two letters of recommendation'],
  benefits: ['Full tuition coverage', 'Monthly stipend for living expenses', 'Annual round-trip tickets', 'Health insurance', 'Guaranteed employment with Emirates upon graduation', 'Internship opportunities within Emirates operations', 'Mentorship from aviation industry professionals', 'Access to Emirates training facilities'],
  applicationProcess: ['Online application submission', 'Initial screening', 'Assessment center evaluation', 'Panel interview with Emirates representatives', 'Psychometric testing', 'Final selection and notification']
}];
const ScholarshipDetail = () => {
  const navigate = useNavigate();
  const {
    scholarshipId
  } = useParams();
  const [scholarship, setScholarship] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  useEffect(() => {
    // In a real app, this would be an API call
    const foundScholarship = scholarshipsData.find(s => s.id === scholarshipId);
    setScholarship(foundScholarship);
  }, [scholarshipId]);
  // Format date for display
  const formatDate = dateString => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  // Calculate days remaining until deadline
  const getDaysRemaining = dateString => {
    const deadline = new Date(dateString);
    const today = new Date();
    const diffTime = deadline.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  if (!scholarship) {
    return <Layout title="Scholarship Details" persona="Student" data-id="element-5237">
        <div className="max-w-5xl mx-auto bg-white rounded-lg border border-gray-200 shadow-sm p-8 text-center" data-id="element-5238">
          <p data-id="element-5239">Loading scholarship details...</p>
        </div>
      </Layout>;
  }
  const isElite = scholarship.track === 'Elite';
  const daysRemaining = getDaysRemaining(scholarship.deadline);
  return <Layout title="Scholarship Details" persona="Student" data-id="element-5240">
      <div className="max-w-5xl mx-auto" data-id="element-5241">
        {/* Back button */}
        <button onClick={() => navigate('/student/scholarships')} className="mb-6 inline-flex items-center text-gray-700 hover:text-primary-600 transition-colors" data-id="element-5242">
          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-5243" />
          Back to Scholarships
        </button>
        {/* Scholarship header */}
        <div className={`rounded-xl overflow-hidden border ${isElite ? 'border-primary-200 bg-gradient-to-r from-primary-50 to-white' : 'border-gray-200 bg-white'} shadow-md mb-6`} data-id="element-5244">
          <div className="p-6" data-id="element-5245">
            <div className="flex flex-col md:flex-row md:items-start gap-6" data-id="element-5246">
              <div className={`h-16 w-16 rounded-xl flex items-center justify-center text-white text-lg font-bold ${isElite ? 'bg-primary-600' : 'bg-secondary-600'}`} data-id="element-5247">
                {scholarship.logo}
              </div>
              <div className="flex-grow" data-id="element-5248">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-id="element-5249">
                  <div data-id="element-5250">
                    <div className="flex items-center gap-2 mb-2" data-id="element-5251">
                      {isElite ? <div className="flex items-center bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-sm" data-id="element-5252">
                          <SparklesIcon className="w-3 h-3 mr-1" data-id="element-5253" />
                          Elite Track
                        </div> : <div className="flex items-center bg-secondary-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-sm" data-id="element-5254">
                          <BriefcaseIcon className="w-3 h-3 mr-1" data-id="element-5255" />
                          Partnership
                        </div>}
                      <div className={`px-2 py-1 rounded-full text-xs font-medium ${daysRemaining < 14 ? 'bg-red-100 text-red-800' : daysRemaining < 30 ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-5256">
                        {daysRemaining} days left to apply
                      </div>
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-5257">
                      {scholarship.title}
                    </h1>
                    <div className="flex items-center mb-1" data-id="element-5258">
                      <GraduationCapIcon className="w-4 h-4 text-gray-500 mr-2" data-id="element-5259" />
                      <span className="text-gray-700" data-id="element-5260">
                        {scholarship.university}
                      </span>
                    </div>
                    <div className="flex items-center mb-1" data-id="element-5261">
                      <BookOpenIcon className="w-4 h-4 text-gray-500 mr-2" data-id="element-5262" />
                      <span className="text-gray-700" data-id="element-5263">
                        {scholarship.program}
                      </span>
                    </div>
                    <div className="flex items-center mb-1" data-id="element-5264">
                      <MapPinIcon className="w-4 h-4 text-gray-500 mr-2" data-id="element-5265" />
                      <span className="text-gray-700" data-id="element-5266">
                        {scholarship.location}
                      </span>
                    </div>
                    {scholarship.employer && <div className="flex items-center mb-1" data-id="element-5267">
                        <BriefcaseIcon className="w-4 h-4 text-gray-500 mr-2" data-id="element-5268" />
                        <span className="text-gray-700" data-id="element-5269">
                          {scholarship.employer}
                        </span>
                      </div>}
                  </div>
                  <div className="flex flex-col gap-3" data-id="element-5270">
                    <div className="flex items-center" data-id="element-5271">
                      <CalendarIcon className="w-4 h-4 text-gray-500 mr-2" data-id="element-5272" />
                      <span className="text-gray-700" data-id="element-5273">
                        Deadline: {formatDate(scholarship.deadline)}
                      </span>
                    </div>
                    <button onClick={() => navigate(`/student/scholarship-application/${scholarship.id}`)} className={`px-6 py-3 rounded-lg text-white font-medium transition-colors ${isElite ? 'bg-primary-600 hover:bg-primary-700' : 'bg-secondary-600 hover:bg-secondary-700'}`} data-id="element-5274">
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Coverage badges */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 mb-6" data-id="element-5275">
          <h3 className="text-sm font-medium text-gray-500 uppercase mb-3" data-id="element-5276">
            Scholarship Coverage
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-5277">
            {scholarship.coverageTypes.map((type, index) => <div key={index} className={`inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium ${isElite ? 'bg-primary-100 text-primary-800' : 'bg-green-100 text-green-800'}`} data-id="element-5278">
                <CheckIcon className="w-4 h-4 mr-1.5" data-id="element-5279" />
                {type}
              </div>)}
          </div>
        </div>
        {/* Tab navigation */}
        <div className="bg-white rounded-t-lg border border-gray-200 border-b-0 shadow-sm" data-id="element-5280">
          <div className="flex overflow-x-auto" data-id="element-5281">
            <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'overview' ? `${isElite ? 'border-primary-500 text-primary-600' : 'border-secondary-500 text-secondary-600'}` : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('overview')} data-id="element-5282">
              Overview
            </button>
            <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'requirements' ? `${isElite ? 'border-primary-500 text-primary-600' : 'border-secondary-500 text-secondary-600'}` : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('requirements')} data-id="element-5283">
              Requirements
            </button>
            <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'benefits' ? `${isElite ? 'border-primary-500 text-primary-600' : 'border-secondary-500 text-secondary-600'}` : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('benefits')} data-id="element-5284">
              Benefits
            </button>
            <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'process' ? `${isElite ? 'border-primary-500 text-primary-600' : 'border-secondary-500 text-secondary-600'}` : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('process')} data-id="element-5285">
              Application Process
            </button>
          </div>
        </div>
        {/* Tab content */}
        <div className="bg-white rounded-b-lg border border-gray-200 shadow-sm p-6 mb-6" data-id="element-5286">
          {activeTab === 'overview' && <div data-id="element-5287">
              <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-5288">
                Scholarship Overview
              </h2>
              <p className="text-gray-700 mb-6 whitespace-pre-line" data-id="element-5289">
                {scholarship.longDescription}
              </p>
              <div className="flex justify-center mt-8" data-id="element-5290">
                <button onClick={() => navigate(`/student/scholarship-application/${scholarship.id}`)} className={`px-6 py-3 rounded-lg text-white font-medium transition-colors ${isElite ? 'bg-primary-600 hover:bg-primary-700' : 'bg-secondary-600 hover:bg-secondary-700'} flex items-center`} data-id="element-5291">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2" data-id="element-5292" />
                  Start Application
                </button>
              </div>
            </div>}
          {activeTab === 'requirements' && <div data-id="element-5293">
              <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-5294">
                Eligibility Requirements
              </h2>
              <ul className="space-y-3 mb-6" data-id="element-5295">
                {scholarship.requirements.map((req, index) => <li key={index} className="flex items-start" data-id="element-5296">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5297" />
                    <span className="text-gray-700" data-id="element-5298">{req}</span>
                  </li>)}
              </ul>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6" data-id="element-5299">
                <h3 className="text-sm font-medium text-gray-500 uppercase mb-2" data-id="element-5300">
                  Important Note
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-5301">
                  All documents must be submitted in English or Arabic.
                  Translations must be certified. Incomplete applications will
                  not be considered.
                </p>
              </div>
            </div>}
          {activeTab === 'benefits' && <div data-id="element-5302">
              <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-5303">
                Scholarship Benefits
              </h2>
              <ul className="space-y-3 mb-6" data-id="element-5304">
                {scholarship.benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-5305">
                    <AwardIcon className="w-5 h-5 text-primary-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5306" />
                    <span className="text-gray-700" data-id="element-5307">{benefit}</span>
                  </li>)}
              </ul>
            </div>}
          {activeTab === 'process' && <div data-id="element-5308">
              <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-5309">
                Application Process
              </h2>
              <ol className="relative border-l border-gray-200 ml-3 mb-6" data-id="element-5310">
                {scholarship.applicationProcess.map((step, index) => <li key={index} className="mb-6 ml-6" data-id="element-5311">
                    <span className={`absolute flex items-center justify-center w-8 h-8 rounded-full -left-4 ring-4 ring-white ${isElite ? 'bg-primary-500' : 'bg-secondary-500'} text-white`} data-id="element-5312">
                      {index + 1}
                    </span>
                    <h3 className="font-medium text-gray-900 mb-1" data-id="element-5313">
                      Step {index + 1}
                    </h3>
                    <p className="text-gray-700" data-id="element-5314">{step}</p>
                  </li>)}
              </ol>
              <div className="flex justify-center mt-8" data-id="element-5315">
                <button onClick={() => navigate(`/student/scholarship-application/${scholarship.id}`)} className={`px-6 py-3 rounded-lg text-white font-medium transition-colors ${isElite ? 'bg-primary-600 hover:bg-primary-700' : 'bg-secondary-600 hover:bg-secondary-700'} flex items-center`} data-id="element-5316">
                  <FileTextIcon className="w-5 h-5 mr-2" data-id="element-5317" />
                  Apply for Scholarship
                </button>
              </div>
            </div>}
        </div>
        {/* Additional resources */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 mb-6" data-id="element-5318">
          <h3 className="text-sm font-medium text-gray-500 uppercase mb-4" data-id="element-5319">
            Related Resources
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5320">
            <a href="#" className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-5321">
              <div className="bg-gray-100 p-2 rounded-md mr-3" data-id="element-5322">
                <ExternalLinkIcon className="w-5 h-5 text-gray-600" data-id="element-5323" />
              </div>
              <div data-id="element-5324">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-5325">
                  University Website
                </h4>
                <p className="text-xs text-gray-500" data-id="element-5326">
                  Visit the official website for more information
                </p>
              </div>
            </a>
            <a href="#" className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-5327">
              <div className="bg-gray-100 p-2 rounded-md mr-3" data-id="element-5328">
                <FileTextIcon className="w-5 h-5 text-gray-600" data-id="element-5329" />
              </div>
              <div data-id="element-5330">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-5331">
                  Program Brochure
                </h4>
                <p className="text-xs text-gray-500" data-id="element-5332">
                  Download detailed information about the program
                </p>
              </div>
            </a>
          </div>
        </div>
        {/* Apply CTA */}
        <div className={`rounded-lg shadow-md overflow-hidden mb-6 ${isElite ? 'bg-primary-50 border border-primary-100' : 'bg-secondary-50 border border-secondary-100'}`} data-id="element-5333">
          <div className="p-6" data-id="element-5334">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-5335">
              <div data-id="element-5336">
                <h3 className={`text-lg font-semibold ${isElite ? 'text-primary-800' : 'text-secondary-800'} mb-2`} data-id="element-5337">
                  Ready to apply for this scholarship?
                </h3>
                <p className="text-gray-600 mb-0" data-id="element-5338">
                  Application deadline: {formatDate(scholarship.deadline)} (
                  {daysRemaining} days remaining)
                </p>
              </div>
              <button onClick={() => navigate(`/student/scholarship-application/${scholarship.id}`)} className={`px-6 py-3 rounded-lg text-white font-medium transition-colors ${isElite ? 'bg-primary-600 hover:bg-primary-700' : 'bg-secondary-600 hover:bg-secondary-700'} flex items-center whitespace-nowrap`} data-id="element-5339">
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
};
export default ScholarshipDetail;